import React from 'react';
import { Hero2Column } from '@/components/sections/Hero/Hero2Column';
import { Leadership } from '@/components/sections/Leadership/Leadership';
import { Investors } from '@/components/sections/Investors/Investors';
import { Careers } from '@/components/sections/Careers/Careers';
import { CTA } from '@/components/sections/CTA/CTA';
import { Recognition } from '@/components/sections/Recognition/Recognition';
import { CaseStudy } from '@/components/sections/CaseStudy/CaseStudy';
import PageWrapper from '@/components/layout/PageWrapper';
import { META } from '@/config/constants';
import { leadershipMembers, investors, careerImages, recognitionBadges, aboutData } from '@/config/aboutData';

const AboutPage: React.FC = () => {
  return (
    <PageWrapper
      title={META.ABOUT.TITLE}
      description={META.ABOUT.DESCRIPTION}
      keywords={["about Cobalt", "embedded iPaaS mission", "integration platform", "SaaS integration company"]}
    >
      <div className="text-center md:text-left">
        <Hero2Column
          title={aboutData.hero.title}
          subtext={aboutData.hero.subtext}
          image="/about-us/about-us-hero.png"
          tagHref="#"
        />

        <Leadership
          title={aboutData.leadership.title}
          description={aboutData.leadership.description}
          members={leadershipMembers}
        />

        <Investors
          title={aboutData.investors.title}
          description={aboutData.investors.description}
          investors={investors}
        />

        <Careers
          tag={aboutData.careers.tag}
          title={aboutData.careers.title}
          description={aboutData.careers.description}
          buttonText={aboutData.careers.buttonText}
          buttonHref={aboutData.careers.buttonHref}
          images={careerImages}
        />

        <Recognition
          tag={aboutData.recognition.tag}
          title={aboutData.recognition.title}
          description={aboutData.recognition.description}
          badges={recognitionBadges}
        />

        <CaseStudy
          title={aboutData.caseStudy.title}
          description={aboutData.caseStudy.description}
          personName={aboutData.caseStudy.personName}
          personTitle={aboutData.caseStudy.personTitle}
          buttonText={aboutData.caseStudy.buttonText}
          buttonUrl={aboutData.caseStudy.buttonUrl}
          imageSrc={aboutData.caseStudy.imageSrc}
          imageAlt={aboutData.caseStudy.imageAlt}
        />

        <CTA
          title={aboutData.cta.title}
          description={aboutData.cta.description}
          cta={aboutData.cta.cta}
        />
      </div>
    </PageWrapper>
  );
};

export default AboutPage;